export const GET_ALL_PROJECTS = "GET_ALL_PROJECTS";
export const ADD_UPDATE_SITE_PROJECT = "ADD_UPDATE_SITE_PROJECT";
export const ADD_UPDATE_SITE_PROJECT_FAILURE = "ADD_UPDATE_SITE_PROJECT_FAILURE";
